import React from "react";
import PropTypes from "prop-types";
import {isAllBlank, isAllNotBlank, isNotBlank} from "../../../util/StringUtil";
import {getFormInputCssClass, hasMessage, setupOnExtractData} from "../../../util/FormUtil";

const securityQuestionOptions = [
    "What is the name of your childhood best friend?",
    "Secret passphrase",
    "What was the last name of your third grade teacher?",
    "What was the name of your second pet?",
    "When you were young, what did you want to be when you grew up?",
    "Who was your childhood hero?",
    "What was the first novel you read?",
    "What was the first foreign city you visited?",
    "What was your favorite childhood cartoon character?",
    "In what city did your parents first meet?",
    "What is the FIRST NAME of your best man/maid of honor at your wedding?",
    "What was the model of your first car or motorcycle?",
    "Where did you and your spouse meet for the first time? (Enter the full name of the CITY only)",
    "What was the last name of your favorite teacher in high school?",
    "In what city was the hospital where you were born?",
    "Who is your favorite artist, group, or band?"
];

export const PROP_NAME_SEC_Q = "securityQuestion";
export const PROP_NAME_SEC_ANS = "securityAnswer";
export const PROP_NAME_CONFIRM_SEC_ANS = "confirmSecurityAnswer";


class SecurityQuestionInputComponent extends React.Component {
    constructor(props){
        super(props);
        this.state = {};
        this.setQuestion = this.setQuestion.bind(this);
        this.setAnswer = this.setAnswer.bind(this);
        this.setConfirmAnswer = this.setConfirmAnswer.bind(this);
        this.setValue = this.setValue.bind(this);
        this.setShowQuestionOptions = this.setShowQuestionOptions.bind(this);
        this.showQuestionOptions = this.showQuestionOptions.bind(this);
        this.hideQuestionOptions = this.hideQuestionOptions.bind(this);
        this.getPropertyName = this.getPropertyName.bind(this);
        this.setDirty = this.setDirty.bind(this);
        this.setQuestionDirty = this.setQuestionDirty.bind(this);
        this.setAnswerDirty = this.setAnswerDirty.bind(this);
        this.setConfirmAnswerDirty = this.setConfirmAnswerDirty.bind(this);
        this.checkRequired = this.checkRequired.bind(this);
        this.checkPattern = this.checkPattern.bind(this);
        this.checkField = this.checkField.bind(this);
        this.validate = this.validate.bind(this);
        this.extractData = this.extractData.bind(this);
        this.toggleShowQuestionOptions = this.toggleShowQuestionOptions.bind(this);

        const PROP_DATA = {};
        const {userDataInit: {securityQnA: {questionPattern, answerPattern, questionMaxLength, answerMaxLength}}} = props;
        PROP_DATA[PROP_NAME_SEC_Q] = {label: "Security Question", pattern: questionPattern, maxLength: questionMaxLength};
        PROP_DATA[PROP_NAME_SEC_ANS] = {label: "Answer", pattern: answerPattern, maxLength: answerMaxLength};
        PROP_DATA[PROP_NAME_CONFIRM_SEC_ANS] = {label: "Confirm Answer", pattern: answerPattern, maxLength: answerMaxLength};
        this.PROP_DATA = PROP_DATA;

    }

    componentDidMount() {
        const {required, setFormState, metadata, data} = this.props;

        const questionPropName = this.getPropertyName(PROP_NAME_SEC_Q);
        const answerPropName = this.getPropertyName(PROP_NAME_SEC_ANS);
        const confAnswerPropName = this.getPropertyName(PROP_NAME_CONFIRM_SEC_ANS);

        const keys = [questionPropName, answerPropName, confAnswerPropName];
        for (let i = 0; i < keys.length; i++){
            const key = keys[i];
            if (! metadata[key]){
                setFormState({property: key, metadata: {valid: ! required || isNotBlank(data[key])}});
            }
        }

        setupOnExtractData(this);
    }

    setQuestion(e){
        this.setValue(PROP_NAME_SEC_Q, e);
    }

    setAnswer(e){
        this.setValue(PROP_NAME_SEC_ANS, e);
    }

    setConfirmAnswer(e){
        this.setValue(PROP_NAME_CONFIRM_SEC_ANS, e);
    }

    setValue(name, e){
        const {data} = this.props;
        let value = typeof(e) === "string" ? e : e.target.value;
        const propertyName = this.getPropertyName(name);
        const futureData = {...data};
        futureData[propertyName] = value;
        this.validate(futureData, propertyName);
    }

    validate(data, targetProperty){
        const {index, setFormState, extraValidation} = this.props;
        const questionPropName = this.getPropertyName(PROP_NAME_SEC_Q);
        const ansPropName = this.getPropertyName(PROP_NAME_SEC_ANS);
        const confAnsPropName = this.getPropertyName(PROP_NAME_CONFIRM_SEC_ANS);
        const questionValue = data[questionPropName];
        const ansValue = data[ansPropName];
        const confAnsValue = data[confAnsPropName];

        const targetFields = [questionPropName, ansPropName, confAnsPropName];
        const {metadata, required} = this.props;
        const updateObj = {};
        const formStateParams = [];
        for (let i = 0; i < targetFields.length; i++){
            const property = targetFields[i];
            // reset everything except dirty flag
            const newMetadata = metadata[property] ? {...metadata[property], valid: true, message: null} : {};
            updateObj[property] = {property, data: data[property], metadata: newMetadata};
            formStateParams.push(updateObj[property]);
        }
        if (targetProperty) {
            updateObj[targetProperty].metadata.dirty = true;
        }
        const questionPropInfo = this.PROP_DATA[PROP_NAME_SEC_Q];
        const ansPropInfo = this.PROP_DATA[PROP_NAME_SEC_ANS];
        const confAnsPropInfo = this.PROP_DATA[PROP_NAME_CONFIRM_SEC_ANS];

        this.checkField(questionValue, questionPropInfo, updateObj[questionPropName].metadata);
        this.checkField(ansValue, ansPropInfo, updateObj[ansPropName].metadata);
        this.checkField(confAnsValue, confAnsPropInfo, updateObj[confAnsPropName].metadata);

        if (! required && ! this.isAllNotBlank(data) && ! this.isAllBlank(data)){
            this.checkRequired(questionValue, questionPropInfo, updateObj[questionPropName].metadata, true);
            this.checkRequired(ansValue, ansPropInfo, updateObj[ansPropName].metadata, true);
            this.checkRequired(confAnsValue, confAnsPropInfo, updateObj[confAnsPropName].metadata, true);
        }
        if(confAnsValue != null && ansValue != null){
            if (confAnsValue.toUpperCase() !== ansValue.toUpperCase()){
                updateObj[confAnsPropName].metadata.valid = false;
                updateObj[confAnsPropName].metadata.message = confAnsPropInfo.label + " " + index + " must be the same as " + ansPropInfo.label + " " + index;
            }
        }
        else if (confAnsValue !== ansValue){
            updateObj[confAnsPropName].metadata.valid = false;
            updateObj[confAnsPropName].metadata.message = confAnsPropInfo.label + " " + index + " must be the same as " + ansPropInfo.label + " " + index;
        }
        if (extraValidation) {
            extraValidation(data, metadata, formStateParams);
        }
        setFormState(formStateParams);

    }

    checkRequired(value, propInfo, metadata, ignoreRequiredProp){
        const {index} = this.props;
        if (! ignoreRequiredProp && ! this.props.required){
            return true;
        }
        metadata.valid = value && value.trim().length > 0;
        if (! metadata.valid){
            metadata.message = propInfo.label + " " + index + " is required";
        }
        return metadata.valid;
    }

    checkPattern(value="", propInfo, metadata){
        const {index} = this.props;
        metadata.valid = propInfo.pattern.test(value);
        if (! metadata.valid){
            metadata.message = propInfo.label + " " + index + " contains invalid characters"
        }
        return metadata.valid;
    }

    checkField(value, propInfo, metadata){
        if (this.checkPattern(value, propInfo, metadata)){
            this.checkRequired(value, propInfo, metadata);
        }
    }

    isAllBlank(data){
        const secQ = data[this.getPropertyName(PROP_NAME_SEC_Q)];
        const secAns = data[this.getPropertyName(PROP_NAME_SEC_ANS)];
        const confSecAns = data[this.getPropertyName(PROP_NAME_CONFIRM_SEC_ANS)];
        return isAllBlank(secQ, secAns, confSecAns);
    }

    isAllNotBlank(data){
        const secQ = data[this.getPropertyName(PROP_NAME_SEC_Q)];
        const secAns = data[this.getPropertyName(PROP_NAME_SEC_ANS)];
        const confSecAns = data[this.getPropertyName(PROP_NAME_CONFIRM_SEC_ANS)];
        return isAllNotBlank(secQ, secAns, confSecAns);
    }

    getPropertyName(baseName){
        const{index} = this.props;
        return baseName + index;
    }

    setShowQuestionOptions(showQuestionOptions) {
        this.setState(state => ({...state, showQuestionOptions}));
    }

    toggleShowQuestionOptions(){
        const {showQuestionOptions} = this.state;
        this.setShowQuestionOptions(! showQuestionOptions);
    }

    showQuestionOptions(){
        this.setShowQuestionOptions(true);
    }

    hideQuestionOptions(){
        setTimeout(() => this.setShowQuestionOptions(false),200);
    }

    setDirty(baseName){
        const propertyName = this.getPropertyName(baseName);
        const {data} = this.props;
        this.validate(data, propertyName);
    }

    setQuestionDirty(){
        this.setDirty(PROP_NAME_SEC_Q);
    }

    setAnswerDirty(){
        this.setDirty(PROP_NAME_SEC_ANS);
    }

    setConfirmAnswerDirty(){
        this.setDirty(PROP_NAME_CONFIRM_SEC_ANS);
    }

    extractData(){
        const {data} = this.props;
        const questionPropName = this.getPropertyName(PROP_NAME_SEC_Q);
        if (isNotBlank(data[questionPropName])){
            const ansPropName = this.getPropertyName(PROP_NAME_SEC_ANS);
            const result = {};
            result[questionPropName] = data[questionPropName];
            result[ansPropName] = data[ansPropName];
            return result;
        } else {
            return null;
        }
    }

    render(){
        const {index, data, required, metadata} = this.props;
        const {showQuestionOptions} =  this.state;
        const questionPropName = this.getPropertyName(PROP_NAME_SEC_Q);
        const answerPropName = this.getPropertyName(PROP_NAME_SEC_ANS);
        const confirmAnsPropName = this.getPropertyName(PROP_NAME_CONFIRM_SEC_ANS);

        const question = data[questionPropName] ? data[questionPropName] : "";
        const answer = data[answerPropName] ? data[answerPropName] : "";
        const confirmAnswer = data[confirmAnsPropName] ? data[confirmAnsPropName] : "";
        const requiredClassName = required ? "" : " optional";
        const inputCssSecQ = getFormInputCssClass(metadata, questionPropName);
        const inputCssSecAns = getFormInputCssClass(metadata, answerPropName);
        const inputCssConfSecAns = getFormInputCssClass(metadata, confirmAnsPropName);
        const questionPropInfo = this.PROP_DATA[PROP_NAME_SEC_Q];
        const answerPropInfo = this.PROP_DATA[PROP_NAME_SEC_ANS];
        const confirmAnsPropInfo = this.PROP_DATA[PROP_NAME_CONFIRM_SEC_ANS];

        return (
            <div>
                <ul className="form-fields grid">
                    <li className={"grid__col-md-6 grid__col-sm-12" + requiredClassName + (showQuestionOptions ? " hard--bottom" : "")}>
                        <label htmlFor={PROP_NAME_SEC_Q + index}>{this.PROP_DATA[PROP_NAME_SEC_Q].label} {index}</label>
                        <input
                            id={PROP_NAME_SEC_Q + index}
                            name={PROP_NAME_SEC_Q + index}
                            type="text"
                            className={"text-input text-input--large responsive" + inputCssSecQ}
                            onChange={this.setQuestion}
                            onFocus={this.showQuestionOptions}
                            onBlur={this.hideQuestionOptions}
                            value={question}
                            maxLength={questionPropInfo.maxLength}
                        />
                        <div className="clickable icon__wrapper icon__wrapper--right"  onClick={this.toggleShowQuestionOptions}><i
                            className={"fa fa-caret-" + (showQuestionOptions ? "up" : "down")}></i></div>
                        {
                            hasMessage(metadata, questionPropName) &&
                            <div className="error">{metadata[questionPropName].message}</div>
                        }
                    </li>
                    <li className="grid__col-md-6 grid__col-sm-12 hard"></li>
                    {
                        showQuestionOptions &&
                        <li className="grid__col-12 hard--top">
                            <div>
                                <em>Choose from below or type your own.</em>
                            </div>
                            {
                                <table className="table table--light table--striped table--striped">
                                    <tbody>
                                    {
                                        securityQuestionOptions.map(
                                            q => (
                                                <tr>
                                                    <td className="clickable" onClick={() => {
                                                        this.setQuestion(q);
                                                        this.hideQuestionOptions();
                                                    }}>{q}</td>
                                                </tr>
                                            )
                                        )
                                    }
                                    </tbody>
                                </table>
                            }
                        </li>
                    }
                    <li className={"grid__col-md-6 grid__col-sm-12" + requiredClassName}>
                        <label htmlFor={PROP_NAME_SEC_ANS + index}>{this.PROP_DATA[PROP_NAME_SEC_ANS].label} {index}</label>
                        <input
                            value={answer}
                            name={PROP_NAME_SEC_ANS + index}
                            id={PROP_NAME_SEC_ANS + index}
                            type="password"
                            className={"text-input text-input--large responsive" + inputCssSecAns}
                            onChange={this.setAnswer}
                            maxLength={answerPropInfo.maxLength}
                            onBlur={this.setAnswerDirty}
                        />
                        {
                            hasMessage(metadata, answerPropName) &&
                            <div className="error">{metadata[answerPropName].message}</div>
                        }
                    </li>
                    <li className={"grid__col-md-6 grid__col-sm-12" + requiredClassName}>
                        <label htmlFor={PROP_NAME_CONFIRM_SEC_ANS + index}>{this.PROP_DATA[PROP_NAME_CONFIRM_SEC_ANS].label} {index}</label>
                        <input
                            value={confirmAnswer}
                            name={PROP_NAME_CONFIRM_SEC_ANS + index}
                            id={PROP_NAME_CONFIRM_SEC_ANS + index}
                            type="password"
                            className={"text-input text-input--large responsive" + inputCssConfSecAns}
                            onChange={this.setConfirmAnswer}
                            maxLength={confirmAnsPropInfo.maxLength}
                            onBlur={this.setConfirmAnswerDirty}
                        />
                        {
                            hasMessage(metadata, confirmAnsPropName) &&
                            <div className="error">{metadata[confirmAnsPropName].message}</div>
                        }
                    </li>
                </ul>
            </div>
        );
    }
}

SecurityQuestionInputComponent.propTypes = {
    data: PropTypes.object.isRequired,
    metadata: PropTypes.object.isRequired,
    setFormState: PropTypes.func.isRequired,
    userDataInit: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    required: PropTypes.bool.isRequired,
    extraValidation: PropTypes.func,
    onExtractData: PropTypes.func
};

export default SecurityQuestionInputComponent;